// extracted by mini-css-extract-plugin
export default {"wrap":"Item_wrap__ob3Da","disabled":"Item_disabled__L5WPa","head":"Item_head__BxFd7","actions":"Item_actions__iAWdo","allow":"Item_allow__ADu8Q"};